(function() {
  var dataEl = document.getElementById('docfinder-data');
  var firstDocs = dataEl ? JSON.parse(dataEl.textContent) : [];

  /* ───── Mehr als 250 Einträge (07.10.2026): weitere Seiten über die
     Section-Rendering-API nachladen (Liquid-paginate liefert max. 250) ───── */
  var pageCount = dataEl ? (parseInt(dataEl.getAttribute('data-pages'), 10) || 1) : 1;
  var sectionId = dataEl ? dataEl.getAttribute('data-section') : '';
  var listed = {};
  try {
    var listedEl = document.getElementById('docfinder-listed');
    (JSON.parse(listedEl ? listedEl.textContent : '[]') || []).forEach(function(h) { if (h) listed[h] = true; });
  } catch (e) {}

  // Folgeseiten: Varianten nicht gelisteter Produkte hier filtern (in Liquid
  // ist die Produktliste auf Seite 2+ leer), Modelle/Priorität neu ableiten.
  function normalizeExtra(items) {
    return items.map(function(it) {
      var vs = (it.variants || []).filter(function(v) { return !v.handle || listed[v.handle]; });
      var models = [];
      var prio = 99;
      vs.forEach(function(v) {
        if (models.indexOf(v.product) === -1) models.push(v.product);
        var p = parseInt(v.priority, 10);
        if (!isNaN(p) && p < prio) prio = p;
      });
      it.variants = vs;
      it.models = models;
      it.priority = prio;
      return it;
    });
  }

  // Folgeseite über paginate.next.url (Shopify nutzt für Metaobjekte einen
  // eigenen Parameter, z. B. page_564274e4=2) + Section-Rendering-API.
  function loadNext(nextUrl, acc, guard) {
    if (!nextUrl || guard > 10) return Promise.resolve(acc);
    var u = new URL(nextUrl, window.location.origin);
    var cur = new URLSearchParams(window.location.search);
    cur.forEach(function(v, k) { if (!u.searchParams.has(k)) u.searchParams.set(k, v); });
    u.searchParams.set('section_id', sectionId);
    return fetch(u.pathname + u.search, { credentials: 'same-origin' })
      .then(function(r) { return r.ok ? r.text() : ''; })
      .then(function(html) {
        if (!html) return acc;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var el = doc.getElementById('docfinder-data');
        if (!el || el.getAttribute('data-page') === '1') return acc;
        acc = acc.concat(normalizeExtra(JSON.parse(el.textContent)));
        return loadNext(el.getAttribute('data-next'), acc, guard + 1);
      })
      .catch(function() { return acc; });
  }

  var firstNext = dataEl ? dataEl.getAttribute('data-next') : '';
  if (pageCount > 1 && firstNext && sectionId && window.fetch && window.URL) {
    loadNext(firstNext, firstDocs, 0).then(init);
  } else {
    init(firstDocs);
  }

  function init(documents) {

  documents.sort(function(a, b) {
    var aP = (a.priority == null) ? 99 : a.priority;
    var bP = (b.priority == null) ? 99 : b.priority;
    var diff = aP - bP;
    if (diff !== 0) return diff;
    return (a.title || '').localeCompare(b.title || '', 'de');
  });

  var productSelect = document.getElementById('docfinder-product');
  var variantSelect = document.getElementById('docfinder-variant');
  var categorySelect = document.getElementById('docfinder-category');
  var languageSelect = document.getElementById('docfinder-language');
  var resultsWrap = document.getElementById('docfinder-results-wrap');
  var resultsEl = document.getElementById('docfinder-results');
  var emptyEl = document.getElementById('docfinder-empty');
  var modal = document.getElementById('docfinder-modal');
  var modalContent = document.getElementById('docfinder-modal-content');
  var closeBtn = modal.querySelector('.docfinder-close');
  var overlay = modal.querySelector('.docfinder-modal-overlay');

  /* ───── Datenstruktur aufbauen: Produkt → Varianten ───── */
  var productMap = {};        // productTitle → { priority, variants: { key: label } }
  var productOrder = [];

  for (var i = 0; i < documents.length; i++) {
    var variants = documents[i].variants || [];
    for (var j = 0; j < variants.length; j++) {
      var v = variants[j];
      if (!productMap[v.product]) {
        var parsed = parseInt(v.priority, 10);
        productMap[v.product] = {
          priority: isNaN(parsed) ? 99 : parsed,
          variants: {}
        };
        productOrder.push(v.product);
      }
      productMap[v.product].variants[v.key] = v.label;
    }
  }
  productOrder.sort(function(a, b) {
    var diff = productMap[a].priority - productMap[b].priority;
    if (diff !== 0) return diff;
    return a.localeCompare(b, 'de');
  });

  /* ───── Produkt-Select befüllen ───── */
  for (var p = 0; p < productOrder.length; p++) {
    var opt = document.createElement('option');
    opt.value = productOrder[p];
    opt.textContent = productOrder[p];
    productSelect.appendChild(opt);
  }

  /* ───── Variant-Select dynamisch ───── */
  function refreshVariantSelect() {
    var selectedProduct = productSelect.value;
    // reset
    variantSelect.innerHTML = '<option value="">Alle Varianten</option>';
    if (!selectedProduct) {
      variantSelect.disabled = true;
      return;
    }
    var variantMap = productMap[selectedProduct] && productMap[selectedProduct].variants;
    if (!variantMap) {
      variantSelect.disabled = true;
      return;
    }
    var keys = Object.keys(variantMap);
    // Wenn nur 1 Variante (Default) → kein Sinn, deaktiviert lassen
    if (keys.length === 1 && variantMap[keys[0]] === '') {
      variantSelect.disabled = true;
      return;
    }
    keys.sort(function(a, b) {
      return (variantMap[a] || '').localeCompare(variantMap[b] || '', 'de');
    });
    for (var k = 0; k < keys.length; k++) {
      var optEl = document.createElement('option');
      optEl.value = keys[k];
      optEl.textContent = variantMap[keys[k]] || selectedProduct;
      variantSelect.appendChild(optEl);
    }
    variantSelect.disabled = false;
  }

  /* ───── Kategorien (alle) ───── */
  function uniqueCategories() {
    var seen = {};
    var result = [];
    for (var i = 0; i < documents.length; i++) {
      var c = documents[i].category;
      if (c && !seen[c]) { seen[c] = true; result.push(c); }
    }
    return result.sort(function(a, b) { return a.localeCompare(b, 'de'); });
  }
  var cats = uniqueCategories();
  for (var c = 0; c < cats.length; c++) {
    var copt = document.createElement('option');
    copt.value = cats[c];
    copt.textContent = cats[c];
    categorySelect.appendChild(copt);
  }

  /* ───── Sprachen (07.10.2026) ───── */
  var LANG_ORDER = ['de', 'fr', 'it', 'en'];
  function itemLanguages(item) {
    var l = item.languages;
    if (typeof l === 'string') l = [l];
    if (!l || !l.length) l = ['de'];
    return l.map(function(x) { return String(x).toLowerCase(); })
      .sort(function(a, b) { return LANG_ORDER.indexOf(a) - LANG_ORDER.indexOf(b); });
  }
  // Nur Sprachen anbieten, für die es Einträge gibt
  if (languageSelect) {
    var langSeen = {};
    for (var li = 0; li < documents.length; li++) {
      itemLanguages(documents[li]).forEach(function(x) { langSeen[x] = true; });
    }
    Array.prototype.slice.call(languageSelect.options).forEach(function(o) {
      if (o.value && !langSeen[o.value]) o.parentNode.removeChild(o);
    });
  }

  /* ───── Modal + Render (unverändert) ───── */
  function getVideoEmbed(url) {
    var lower = url.toLowerCase();
    if (lower.includes('youtube.com/watch?v=')) {
      return '<iframe src="' + url.replace('watch?v=', 'embed/') + '" allowfullscreen></iframe>';
    }
    if (lower.includes('youtu.be/')) {
      return '<iframe src="' + url.replace('youtu.be/', 'youtube.com/embed/') + '" allowfullscreen></iframe>';
    }
    if (lower.includes('vimeo.com')) {
      var match = url.match(/vimeo\.com\/(\d+)/);
      if (match && match[1]) {
        return '<iframe src="https://player.vimeo.com/video/' + match[1] + '" allowfullscreen></iframe>';
      }
    }
    return '<video controls autoplay playsinline preload="metadata"><source src="' + url + '" type="video/mp4"></video>';
  }

  function openModal(url) {
    modalContent.innerHTML = getVideoEmbed(url);
    modal.classList.add('is-active');
    document.documentElement.style.overflow = 'hidden';
  }

  function closeModal() {
    modal.classList.remove('is-active');
    document.documentElement.style.overflow = '';
    setTimeout(function() { modalContent.innerHTML = ''; }, 400);
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  function renderResults(items) {
    resultsEl.innerHTML = '';
    resultsWrap.style.display = 'block';

    if (!items.length) {
      emptyEl.style.display = 'block';
      return;
    }
    emptyEl.style.display = 'none';

    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var card = document.createElement('div');
      card.className = 'docfinder-card';

      var actions;
      if (item.type === 'video') {
        actions =
          '<div class="docfinder-actions">' +
            '<button class="docfinder-link" data-video="' + escapeHtml(item.url) + '">Video abspielen</button>' +
            '<a class="docfinder-play" href="' + escapeHtml(item.url) + '" download rel="noopener">Download</a>' +
          '</div>';
      } else {
        actions =
          '<div class="docfinder-actions">' +
            '<a class="docfinder-link" href="' + escapeHtml(item.url) + '" target="_blank" rel="noopener">PDF öffnen</a>' +
            '<a class="docfinder-play" href="' + escapeHtml(item.url) + '" download rel="noopener">Download</a>' +
          '</div>';
      }

      // Modellnamen kürzen ("SkyPergola SkyMotion LED Aluminium Pergola" → "SkyMotion LED")
      function shortenModel(name) {
        return String(name || '')
          .replace(/^SkyPergola\s+/i, '')
          .replace(/\s+Aluminium\s+Pergola$/i, '')
          .replace(/\s+Pergola$/i, '')
          .trim();
      }
      var allModels = (item.models || []).map(shortenModel).filter(Boolean);
      var MAX_BADGES = 2;
      var shownModels = allModels.slice(0, MAX_BADGES);
      var hiddenCount = allModels.length - shownModels.length;
      var modelBadges = shownModels.map(function(m) {
        return '<span class="docfinder-badge docfinder-badge--model">' + escapeHtml(m) + '</span>';
      }).join('');
      if (hiddenCount > 0) {
        modelBadges += '<span class="docfinder-badge docfinder-badge--more">+' + hiddenCount + ' weitere</span>';
      }

      var langs = itemLanguages(item);
      var langBadge = '<span class="docfinder-badge docfinder-badge--lang" title="Sprache">' +
        escapeHtml(langs.map(function(x) { return x.toUpperCase(); }).join(' · ')) + '</span>';

      card.innerHTML =
        '<div class="docfinder-badges">' +
          '<span class="docfinder-badge docfinder-badge--type">' + escapeHtml(item.type.toUpperCase()) + '</span>' +
          langBadge +
          modelBadges +
          '<span class="docfinder-badge docfinder-badge--cat">' + escapeHtml(item.category) + '</span>' +
        '</div>' +
        '<h3>' + escapeHtml(item.title) + '</h3>' +
        '<p>' + escapeHtml(item.description || '') + '</p>' +
        actions;

      resultsEl.appendChild(card);
    }

    var videoButtons = resultsEl.querySelectorAll('[data-video]');
    for (var j = 0; j < videoButtons.length; j++) {
      videoButtons[j].addEventListener('click', function() {
        openModal(this.getAttribute('data-video'));
      });
    }
  }

  function filterDocuments() {
    var selectedProduct = productSelect.value;
    var selectedVariant = variantSelect.value;
    var selectedCategory = categorySelect.value;

    var filtered = documents.filter(function(item) {
      var productMatch = !selectedProduct || (item.variants || []).some(function(v) {
        return v.product === selectedProduct;
      });
      var variantMatch = !selectedVariant || (item.variants || []).some(function(v) {
        return v.key === selectedVariant;
      });
      var categoryMatch = !selectedCategory || item.category === selectedCategory;
      var selectedLanguage = languageSelect ? languageSelect.value : '';
      var languageMatch = !selectedLanguage || itemLanguages(item).indexOf(selectedLanguage) !== -1;
      return productMatch && variantMatch && categoryMatch && languageMatch;
    });

    renderResults(filtered);
  }

  productSelect.addEventListener('change', function() {
    refreshVariantSelect();
    filterDocuments();
  });
  variantSelect.addEventListener('change', filterDocuments);
  categorySelect.addEventListener('change', filterDocuments);
  if (languageSelect) languageSelect.addEventListener('change', filterDocuments);

  refreshVariantSelect();
  filterDocuments();

  closeBtn.addEventListener('click', closeModal);
  overlay.addEventListener('click', closeModal);

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && modal.classList.contains('is-active')) {
      closeModal();
    }
  });
}
})();
